import { computed, onMounted, ref } from 'vue'

import type { DropdownOption } from '@/components/common/ui/inputs/inputTypes'
import type { BRMOrganizationBase } from '@/types/external/2work/doctypes/CustomDoctypes'

import AvatarOrganization from '@/components/common/ui/avatar/AvatarOrganization.vue'
import { RelationGroupType, RelationType } from '@/constants/relations'
import { useFrappeNestCustomAPIStore } from '@/stores/apis/frappeNestCustomAPI'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const useOrganizationOptions = () => {
  const customAPIStore = useFrappeNestCustomAPIStore()

  const organizationList = ref<BRMOrganizationBase[]>([])

  const refreshOrganizationList = async (): Promise<void> => {
    organizationList.value = await customAPIStore.getOrganizationList({
      fields: ['name', 'doctype', 'organization_name', 'image', 'email_ids', 'customer_type'],
      limit: 0,
      sub_type: RelationType.all,
      type: RelationGroupType.organizations,
    })
  }

  const organizationOptions = computed<DropdownOption<BRMOrganizationBase>[]>(() => {
    const options = organizationList.value
      .map((organization) => {
        return {
          icon: AvatarOrganization,
          image: organization.image,
          optionLabel: organization.organization_name,
          optionValue: organization,
        }
      })
      .sort((organizationBefore, organizationAfter) => {
        return organizationBefore.optionLabel.localeCompare(organizationAfter.optionLabel)
      })

    return options
  })

  onMounted(async () => {
    await refreshOrganizationList()
  })

  return {
    organizationList,
    organizationOptions,
    refresh: refreshOrganizationList,
  }
}

export { useOrganizationOptions }
